import React from "react";
import { cn } from "../../../lib/utils";
import { FormField, Input } from "../../../shared/ui/composites";
import { COMMISSION_COMPONENTS, sumNumbers, almostEqual } from "../utils/commissionConfig";

export default function StaffMonthlyCommissionTab({ value, onChange }) {
  const components = value?.components || [];
  const enabled = components.filter((c) => c.enabled);
  const weightSum = sumNumbers(enabled.map((c) => c.weight));
  const weightsOk = enabled.length === 0 || almostEqual(weightSum, 100);

  const setAmount = (approved_amount) => onChange({ ...value, approved_amount });
  const patchComponent = (key, patch) => {
    onChange({
      ...value,
      components: components.map((row) =>
        row.key === key ? { ...row, ...patch } : row,
      ),
    });
  };

  return (
    <div className="py-2 min-h-56 space-y-4">
      <FormField
        label="مبلغ مصوب پورسانت ماهانه"
        htmlFor="staff-commission-amount"
        hint="سقف ریالی پورسانت این پرسنل در ماه؛ وزن مؤلفه‌ها روی این مبلغ اعمال می‌شود"
      >
        <div className="flex items-center gap-2">
          <Input
            id="staff-commission-amount"
            type="number"
            min="0"
            step="0.01"
            inputMode="decimal"
            variant="form"
            className="text-left"
            placeholder="مثلاً ۱۰۰۰۰۰.۵۰"
            value={value?.approved_amount ?? ""}
            onChange={(e) => setAmount(e.target.value)}
          />
          <span className="rounded-lg border border-border bg-slate-50 px-3 py-2 text-sm text-slate-500">
            ریال
          </span>
        </div>
      </FormField>

      <div className="rounded-xl border border-border overflow-hidden">
        <div className="border-b border-border bg-slate-50 px-3 py-2">
          <div className="font-semibold text-slate-800">ساختار محاسبه پورسانت</div>
          <p className="text-xs text-slate-500">
            درصد هر کدام از مؤلفه‌های فعال را مشخص کنید. مجموع درصدهای فعال باید برابر ۱۰۰٪ باشد.
          </p>
        </div>
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-indigo-50/60 text-slate-600">
              <th className="px-3 py-2 text-right font-semibold">مؤلفه</th>
              <th className="w-20 px-3 py-2 text-center font-semibold">فعال</th>
              <th className="w-36 px-3 py-2 text-center font-semibold">درصد سهم</th>
            </tr>
          </thead>
          <tbody>
            {COMMISSION_COMPONENTS.map((meta) => {
              const row = components.find((c) => c.key === meta.key) || {
                key: meta.key,
                enabled: true,
                weight: meta.defaultWeight,
              };
              return (
                <tr key={meta.key} className="border-t border-slate-100">
                  <td className="px-3 py-2 font-medium text-slate-800">
                    <span className="ml-2">{meta.icon}</span>
                    {meta.fa}
                  </td>
                  <td className="px-3 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={row.enabled !== false}
                      onChange={(e) => patchComponent(meta.key, { enabled: e.target.checked })}
                    />
                  </td>
                  <td className="px-3 py-2">
                    <label className="flex items-center justify-end gap-1">
                      <Input
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        inputMode="decimal"
                        variant="form"
                        className="h-9 w-20 px-2 text-left"
                        disabled={row.enabled === false}
                        value={row.weight}
                        onChange={(e) => patchComponent(meta.key, { weight: e.target.value })}
                      />
                      <span className="text-xs text-slate-400">%</span>
                    </label>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div
          className={cn(
            "px-3 py-2 text-sm font-semibold",
            weightsOk ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800",
          )}
        >
          مجموع وزن مؤلفه‌ها: {weightSum.toFixed(2)}%
          {!weightsOk ? " — باید برابر ۱۰۰٪ باشد" : ""}
        </div>
      </div>
    </div>
  );
}
